import {
  ChangeDetectionStrategy, Component,
} from '@angular/core'

@Component({
  selector: 'kb-extended-footer',
  templateUrl: './extended-footer.component.html',
  styleUrls: ['./extended-footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
})
export class ExtendedFooterComponent {

}
